/* ------------------------------------------
SLIDES - SWIPERS
-------------------------------------------- */

var sliders = function()
{
	/* BANNER HOME */

	var totalItensBanner = 0;

	$('#bannerHome ul li').each(function()
	{
		totalItensBanner++;
	});

	if( totalItensBanner > 1 )
	{
		var autoplay = $("#bannerHome").data("autoplay");

		if(autoplay === "1" || autoplay === 1) autoplay = true;
		else autoplay = false;

		var owl = $("#bannerHome .owl-carousel").owlCarousel(
		{
			items : 1,
			margin : 0,
			loop : true,
			mouseDrag : true,
			touchDrag : true,
			autoplay : autoplay,
			autoplayTimeout: 5000,
			autoplaySpeed: 2000,
			dotsSpeed: 2000,
			dragEndSpeed: 2000,
			nav: true,
			navSpeed: 2000,
			onDragged: callbackDrag,
			triggerable: callbackDrag
			//info: true,
		});
	}
	else
	{
		var owl = $("#bannerHome .owl-carousel").owlCarousel(
		{
			items : 1,
			margin : 0,
			loop : false,
			mouseDrag : false,
			touchDrag : false,
			autoplay : false,
			nav: false,
		});
	}



	function callbackDrag()
	{
		owl.trigger('stop.owl.autoplay');
	}

	$('#bannerHome .owl-nav button').on('click',function()
	{
		callbackDrag();
	});

	/* CARROSSEL CINEMA HOME */

	$('#cinemaHome .owl-carousel.cinemaHome').owlCarousel(
	{
		margin: 5,
		loop: true,
	    nav: true,
	    mouseDrag: true,
		touchDrag: true,
		navSpeed: 2000,
		autoWidth: true,
		responsive:{
	        0:{
	            items:1,
	            center:true,
	            margin:5,
	            loop:true,
	        },
	        640:{
	            items:3
	        },
	        1000:{
	            items:4
	        },
	        1440:{
	            items:4
	        },
	        1680:{
	            items:6
	        }
	    }
	});


	/* CARROSSEL TEATRO HOME */

	$('#teatroHome .owl-carousel.teatroHome').owlCarousel(
		{
		margin: 5,
		loop: true,
	    nav: true,
	    mouseDrag: true,
		touchDrag: true,
		navSpeed: 2000,
		autoWidth: true,
		responsive:{
	        0:{
	            items:1,
	            center:true,
	            margin:5,
	            loop:true,
	        },
	        640:{
	            items:3
	        },
	        1000:{
	            items:4
	        },
	        1440:{
	            items:4
	        },
	        1680:{
	            items:6
	        }
	    }
	});



	/* CARROSSEL CINEMA INTERNAS */

	$('#cinemaHome .internaCinema').owlCarousel(
	{
		margin: 10,
		items:4,
		loop: false,
		nav: true,
		mouseDrag: true,
		touchDrag: true,
		navSpeed: 600,
		autoWidth: true,
		responsive:{
			0:{
				items:1,
				center:true,
				margin:5,
			},
			640:{
				items:3,
			},
			1000:{
				items:4,
			}
		}
	});

	/* BANNER PUBLICIDADE */

	var totalItensPub = 0;

	$('#bannerPublicidade ul li').each(function()
	{
		totalItensPub++;
	});

	if( totalItensPub > 1 )
	{
		var autoplay = $("#bannerPublicidade").data("autoplay");

		if(autoplay === "1" || autoplay === 1) autoplay = true;
		else autoplay = false;

		var owl = $("#bannerPublicidade .owl-carousel").owlCarousel(
		{
			items : 1,
			margin : 0,
			loop : true,
			mouseDrag : true,
			touchDrag : true,
			autoplay : autoplay,
			autoplayTimeout: 5000,
			autoplaySpeed: 2000,
			dotsSpeed: 2000,
			dragEndSpeed: 2000,
			nav: false,
			navSpeed: 2000,
			onDragged: callbackDrag,
			triggerable: callbackDrag
			//info: true,
		});
	}
	else
	{
		var owl = $("#bannerPublicidade .owl-carousel").owlCarousel(
		{
			items : 1,
			margin : 0,
			loop : false,
			mouseDrag : false,
			touchDrag : false,
			autoplay : false,
			nav: false,
		});
	}

	function callbackDrag()
	{
		owl.trigger('stop.owl.autoplay');
	}

	$('#bannerPublicidade .owl-nav button').on('click',function()
	{
		callbackDrag();
	});


	/* CARROSSEL LOJISTA */

	// carroselLojista

	$('.owl-carousel-lojista').owlCarousel({
		nav:true,
		loop:true,
        video:true,
        lazyLoad:true,

		responsive:{
			0:{
				items:1,
				center:false,
				margin: 10,
				dots: true,
			},
			768:{
				items:1,
				center:false,
				margin: 10,
				dots: true,
			},
			769:{
				items:3,
				center:true,
				margin: 0,
				dots: false,
			},
		}
	});

	
	/* GALERIA DE FOTOS */

	var gallery = $('.fotoGallery.owl-carousel').owlCarousel(
	{
	    margin:0,
	    nav:true,
	    items:1,
	    loop : true,
	});

	/* TIMELINE */

	$('#timeline .owl-carousel').owlCarousel(
	{
		margin:3,
		loop: false,
	    nav: true,
	    mouseDrag: true,
		touchDrag: true,
		navSpeed: 1000,
		responsive:{
	        0:{
	            center:true,
	            items:1,
	            margin:1,
	        },
	        568:{
	        	margin:1,
	            items:2
	        },
	        993:{
	            items:3
	        },
	        1281:{
	            items:4
	        }
	    }
	});

	/* POSTS RELACIONADOS */

	$('#relacionados.lojas .owl-carousel').owlCarousel(
	{
		margin:30,
		loop: false,
	    nav: true,
	    mouseDrag: true,
		touchDrag: true,
		navSpeed: 1000,
		responsive:{
	        0:{
	            //center:true,
	            items:1,
	            margin:5,
	            center:true,
	        },
	        581:{
	            items:3
	        },
	        1180:{
	            items:4
	        }
	    }
	});

	$('#relacionados.cinema .owl-carousel').owlCarousel(
	{
		margin: 30,
		loop: false,
	    nav: true,
	    mouseDrag: true,
		touchDrag: true,
		navSpeed: 1000,
		responsive:{
	        0:{
	            //center:true,
	            items:1,
	            margin:5,
	            loop: false,
	            center:true,
	            autoWidth:false,
	        },
	        580:{
	            items: 3,
	        },
	        740:{
	            items: 2,
	        },
	        1024:{
	            items: 3
	        }
	    }
	});

	$('#relacionados.cinemark .owl-carousel').owlCarousel(
		{
			margin: 15,
			loop: false,
			nav: true,
			mouseDrag: true,
			touchDrag: true,
			navSpeed: 1000,
			responsive:{
				0:{
					//center:true,
					items:1,
					margin:5,
					loop: false,
					center:true,
					autoWidth:false,
				},
				580:{
					items: 4,
				},
				740:{
					items: 3,
				},
				1024:{
					items: 4
				}
			}
		});

	$('#relacionados.projetos .owl-carousel').owlCarousel(
	{
		margin: 30,
		loop: false,
	    nav: true,
	    mouseDrag: true,
		touchDrag: true,
		navSpeed: 1000,
		responsive:{
	        0:{
	            //center:true,
	            items:1,
	            margin:5,
	            loop: false,
	            center:true,
	            autoWidth:false,
	        },
	        580:{
	            items: 3,
	        },
	        740:{
	            items: 2,
	        },
	        1024:{
	            items: 3
	        }
	    }
	});

	$('#relacionados.home .owl-carousel').owlCarousel(
	{
		margin:30,
		loop: false,
	    nav: true,
	    mouseDrag: true,
		touchDrag: true,
		navSpeed: 1000,
		responsive:{
	        0:{
	            //center:true,
	            items:1,
	            margin:5,
	            center:true,
	        },
	        581:{
	            items:3
	        },
	        1180:{
	            items:3
	        }
	    }
	});

	$('#relacionados.home .owl-carousel').owlCarousel(
	{
		margin:30,
		loop: false,
	    nav: true,
	    mouseDrag: true,
		touchDrag: true,
		navSpeed: 1000,
		responsive:{
	        0:{
	            //center:true,
	            items:1,
	            margin:5,
	            center:true,
	        },
	        581:{
	            items:3
	        },
	        1180:{
	            items:3
	        }
	    }
	});

	$('#CarrosselDestaquesHome .owl-carousel').owlCarousel(
	{
		margin:30,
		loop: false,
	    nav: true,
	    mouseDrag: true,
		touchDrag: true,
		navSpeed: 1000,
		// autoWidth:true,
		// autoplay:true,
		// autoplayTimeout:1500,
		// autoplayHoverPause:true,
		responsive:{
	        0:{
				// items:1,
				slideBy: 1,
	            margin:15,
	            center:true,
				loop: true,
			},
			581:{
	            items:2
	        },
	        768:{
	            items:3
	        },
			1024:{
	            items:4
	        }
	    }
	});

	$('#novidadesHome.home .owl-carousel').owlCarousel(
		{
			// margin:30,
			// loop: false,
			// nav: true,
			// mouseDrag: true,
			// touchDrag: true,
			// navSpeed: 1000,
			// responsive:{
			// 	0:{
			// 		//center:true,
			// 		items:1,
			// 		margin:5,
			// 		center:true,
			// 	},
			// 	581:{
			// 		items:3
			// 	},
			// 	1180:{
			// 		items:3
			// 	}
			// }
		}

	);

	/* SWIPER DEPOIMENTOS */

	$('#depoimentos .owl-carousel').owlCarousel(
	{
		margin: 30,
		items: 3,
		loop: true,
	    nav: true,
	    autoHeight:true,
	    mouseDrag: true,
		touchDrag: true,
		navSpeed: 1000,
		responsive:{
	        0:{
	            items:1,
	            margin:0,
	        },
	        740:{
	            items: 2,
	            margin: 40,
	        },
	        1024:{
	            items: 3,
	            margin: 30,
	        }
	    }
	});

	// Grandes numeros

	$('.carrosselNumeros').owlCarousel({
		margin: 30,
		nav: false,
		dots: true,
		items: 4,
		responsive: {
			0: {
				margin: 15,
				items: 1,
			},
			568: {
				margin: 15,
				items: 3,
			},
			1000: {
				margin: 30,
				items: 4,
				dots: true,
			}
		}
	});

	$('.CarrosselTimeline').owlCarousel({
		margin: 30,
		items:3,
		nav: true,
		dots: true,
		slideBy: 1,
		responsive:{
			0:{
				margin: 30,
				items:1,

			},
			568:{
				margin: 30,
				items:2,
			},
			991:{
				margin: 30,
				items:3,
			}
		}
	});

	// CARROSSEL DESTAQUES HOME

	const $carousel = $('#DestaquesCardsHome .owl-carousel');
	const $items = $carousel.find('li');

	if ($items.length > 3)
	{
		$carousel.addClass('EhCarrossel');

		$('#DestaquesCardsHome .owl-carousel').owlCarousel({
			margin: 24,
			items:1,
			slideBy: 1,
			autoWidth: true,
			center: false,
			nav: false,
			dots: false,
			loop: false,
			responsive:{
				0:{
					margin: 14,

				},
				1280:
				{
					margin: 24,
				}
			}
		});
	}
}
